import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        lang: 'zh-cn'
    },
    mutations: {
        TOGGLE_LANG: (state, lang) => {
            state.lang = lang
        }
    },
    actions: {
        toggleLang({ commit }, lang) {
            commit('TOGGLE_LANG', lang)
        }
    },
    modules: {}
})